import { Toast, type ToastProps } from "primereact/toast";
import { forwardRef } from "react";

/**
 * A Toast that always paints above everything else.
 *
 * Two things conspire against a plain <Toast>. #root establishes a stacking
 * context (it has to, so it sits above the ambient background layers), and
 * PrimeReact renders dialogs and their masks on document.body. A toast left
 * inside #root is therefore painted underneath any open dialog no matter how
 * high its own z-index climbs: a wrong-flag message would appear behind the
 * blurred challenge modal that prompted it.
 *
 * Portalling to the body puts the toast in the same stacking context as the
 * mask, where the z-index in prime.css can actually win.
 */
const AppToast = forwardRef<Toast, ToastProps>(function AppToast(props, ref) {
  return (
    <Toast
      ref={ref}
      appendTo={typeof document === "undefined" ? undefined : document.body}
      {...props}
    />
  );
});

export default AppToast;
